<div class="flex flex-1 justify-between sm:hidden">
  <button sb-button [color]="'secondary'" (click)="goToPage(currentPage() - 1)" [disabled]="!canGoToPreviousPage()">
    {{ 'Previous' | translate }}
  </button>
  <button sb-button [color]="'secondary'" (click)="goToPage(currentPage() + 1)" [disabled]="!canGoToNextPage()">
    {{ 'Next' | translate }}
  </button>
</div>
<div
  class="hidden sm:flex sm:flex-1 sm:items-center"
  [ngClass]="{ 'sm:justify-between': showCount, 'sm:justify-center': !showCount }"
>
  @if (showCount) {
    <div>
      <p
        class="m-0 text-base text-default children:font-medium"
        [innerHTML]="
          'Showing {{fromValue}} to {{toValue}} of {{totalValue}} results'
            | translate
              : {
                  fromValue: '<b>' + fromValue() + '</b>',
                  toValue: '<b>' + toValue() + '</b>',
                  totalValue: '<b>' + totalItems + '</b>',
                }
        "
      ></p>
    </div>
  }

  <div class="inline-flex gap-0.5" aria-label="Pagination">
    <button
      sb-icon-button
      [color]="'transparent'"
      (click)="goToPage(currentPage() - 1)"
      [disabled]="!canGoToPreviousPage()"
    >
      <span class="sr-only">{{ 'Previous' | translate }}</span>
      <sb-icon [name]="'left-regular'" />
    </button>

    @for (page of pages; track trackByPage($index, page)) {
      @if (page.type === 'page') {
        <button
          sb-button
          [color]="page.value === currentPage() ? 'primary' : 'transparent'"
          [clickable]="page.value !== currentPage()"
          (click)="goToPage(page.value)"
          [attr.aria-current]="page.value === currentPage() ? 'page' : null"
        >
          {{ page.label }}
        </button>
      } @else {
        <button sb-icon-button [clickable]="false" [color]="'transparent'">
          <sb-icon [name]="'more-1-regular'" />
        </button>
      }
    }

    <button
      sb-icon-button
      [color]="'transparent'"
      (click)="goToPage(currentPage() + 1)"
      [disabled]="!canGoToNextPage()"
    >
      <span class="sr-only">{{ 'Next' | translate }}</span>
      <sb-icon [name]="'right-regular'" />
    </button>
  </div>
</div>
